<div class="ad-container">
  <app-title-container backPath="/assessments">
    <h1>Assessment Detail</h1>
    <div right class="ad-right-btn-container">
      <button matButton="outlined" (click)="createReferral()">
        <mat-icon>add</mat-icon>
        Create Referral
      </button>
      <button matButton="filled" (click)="generateFiles()">
        <mat-icon>picture_as_pdf</mat-icon>

        {{ hasProtectedAreas() ? 'Generate Files' : 'Generate PDF' }}
      </button>
    </div>
  </app-title-container>
  <app-divider height="2px"></app-divider>

  @if (isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    @if (assessmentState() === asyncStateEnum.IN_PROGRESS) {
      <div class="ad-content-container">
        <h3 class="text-green">Coordinates were included therefore the calculation can take longer</h3>
      </div>
    }
  } @else if (assessmentState() === asyncStateEnum.ERROR) {
    <div class="ad-content-container">
      <h3 class="text-red">Something happened, create new Assessment or contact support team</h3>
      <button matButton="outlined" class="add-assessment-btn" (click)="navigateToAssessmentCreation()">
        <mat-icon>add</mat-icon>New Assessment
      </button>
      <button mat-flat-button class="add-assessment-btn" (click)="recalculateAssessment()"><mat-icon>replay</mat-icon>Re-calculate</button>
    </div>
  } @else if (assessmentDetail()) {
    <div class="ad-content-container">
      <div id="pdf-content">
        <div class="content-main-container item-mb">
          <div class="image-container">
            <h1>{{ assessmentDetail()?.sensitivityLevel?.name }}</h1>
            <img class="responsive-img" [src]="imageLink()" alt="Sensitivity img" />
          </div>
          <div class="main-advice-container">
            @if (assessmentDetail()?.mainLobSensLvlAdvice) {
              <div>
                <quill-view [content]="assessmentDetail()?.mainLobSensLvlAdvice?.advice" [sanitize]="true"></quill-view>
              </div>
            } @else if (isThirdPartyMediumRisk() && assessmentDetail()?.thirdPartyAdvice) {
              <div>
                <quill-view [content]="assessmentDetail()?.thirdPartyAdvice" [sanitize]="true"></quill-view>
              </div>
            } @else {
              <div>
                <quill-view [content]="assessmentDetail()?.sensitivityLevel?.header" [sanitize]="true"></quill-view>
              </div>
              <br />
              <div>
                <quill-view [content]="assessmentDetail()?.sensitivityLevel?.body" [sanitize]="true"></quill-view>
              </div>
            }
            <br />
            <p>{{ assessmentDetail()?.sensitivityLevel?.common }}</p>
          </div>
        </div>

        @if (canViewInsights() && insightsContext()) {
          <div class="item-mb">
            <app-insights-panel
              [context]="insightsContext()!"
              [autoGenerate]="autoGenerateInsights"
              [manualGenerationAllowed]="canManuallyGenerateInsights()"
            />
          </div>
        }

        @if (showAdvicePanel()) {
          <mat-expansion-panel class="item-mb" #expansionPanel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title> Advice </mat-panel-title>
            </mat-expansion-panel-header>
            @if (assessmentDetail()?.company?.advice) {
              <h3 class="advice-mb">{{ assessmentDetail()?.company?.name }}</h3>
              <div>
                <quill-view [content]="assessmentDetail()?.company?.advice" [sanitize]="true"></quill-view>
              </div>
              <br />
            }

            @if (assessmentDetail()?.sensitivityLevel?.id !== ABSTAIN_ID && assessmentDetail()?.industrySegment?.industryAdvice) {
              <h3 class="advice-mb">{{ assessmentDetail()?.industrySegment?.name }}</h3>
              <div>
                <quill-view [content]="assessmentDetail()?.industrySegment?.industryAdvice" [sanitize]="true"></quill-view>
              </div>
              <br />
            }

            @if (countrySectorAdvices().length) {
              @for (advice of countrySectorAdvices(); track advice) {
                <h3 class="advice-mb">{{ advice.joinedCountries }}</h3>
                <div>
                  <quill-view [content]="advice.advice.text" [sanitize]="true"></quill-view>
                </div>
                <br />
              }
            }

            @if (hrCountrySectorAdvice().length) {
              @for (advice of hrCountrySectorAdvice(); track advice) {
                <h3 class="advice-mb">{{ advice.joinedCountries }}</h3>
                <div>
                  <quill-view [content]="advice.advice.text" [sanitize]="true"></quill-view>
                </div>
                <br />
              }
            }

            @if (assessmentDetail()?.protectedAreaAdvice) {
              <h3 class="advice-mb">Protected Area</h3>
              <div>
                <quill-view [content]="assessmentDetail()?.protectedAreaAdvice" [sanitize]="true"></quill-view>
              </div>
              <br />
            }

            <app-divider color="second"></app-divider>
            <br />
            <p>
              <strong
                >The scope of the ESG Risk Assessment Tool is limited to ESG risks (i. e. human rights and environmental impacts)</strong
              >
            </p>
            <br />
          </mat-expansion-panel>
        }

        <div class="detail-container">
          <h3 class="detail-header">Assessment details</h3>
          <p class="additional-text">
            If any of the risk parameters change a new assessment is required and thus the current assessment is no longer valid.
          </p>
          <br />

          <div class="detail-grid">
            <app-item-view-container label="Country (risk locations)">
              @for (country of assessmentDetail()?.countries; track country) {
                <div class="detail-country">{{ country.name }}</div>
              }
            </app-item-view-container>

            <app-item-view-container label="Sector">
              {{ assessmentDetail()?.industrySegment?.name }}
            </app-item-view-container>

            <app-item-view-container label="Company">
              {{ companyView() }}
              @if (assessmentDetail()?.matchingMessage) {
                <div class="matching-message">
                  <span class="material-symbols-outlined matching-message-icon"> priority_high </span>
                  <p [innerHtml]="assessmentDetail()?.matchingMessage"></p>
                </div>
              }
            </app-item-view-container>

            <app-item-view-container label="Project">
              {{ projectView() }}
              @if (assessmentDetail()?.projectMatchingMessage) {
                <div class="matching-message">
                  <span class="material-symbols-outlined matching-message-icon"> priority_high </span>
                  <p [innerHtml]="assessmentDetail()?.projectMatchingMessage"></p>
                </div>
              }
            </app-item-view-container>

            <app-item-view-container label="Created by">
              {{ assessmentDetail()?.createdBy?.legalFullName }}
            </app-item-view-container>

            <app-item-view-container label="Created (CET)">
              {{ assessmentDetail()?.createdDate | date: 'yyyy-MM-dd HH:mm:ss' }}
            </app-item-view-container>

            <app-item-view-container label="Business Unit">
              {{ assessmentDetail()?.businessUnit ?? assessmentDetail()?.createdBy?.businessUnit }}
            </app-item-view-container>

            <app-item-view-container label="Legal Entity">
              {{ assessmentDetail()?.legalEntity ?? assessmentDetail()?.createdBy?.legalEntity }}
            </app-item-view-container>

            <app-item-view-container label="Source System">
              {{ assessmentDetail()?.dealSourceSystem }}
            </app-item-view-container>

            <app-item-view-container label="Deal Id">
              {{ assessmentDetail()?.dealSourceSystemId }}
            </app-item-view-container>

            @if (assessmentDetail()?.mainLineOfBusiness) {
              <app-item-view-container label="Main Line Of Business">
                {{ assessmentDetail()?.mainLineOfBusiness?.name }}
              </app-item-view-container>
            }
          </div>
        </div>
      </div>
      @if (assessmentDetail()?.assessmentProtectedAreas?.totalAmount) {
        <div style="padding: 1.5rem">
          <h3 class="detail-header">Locations in Protected Areas</h3>
          <p class="additional-text" data-testid="protected-area-summary-text">{{ protectedAreaSummaryText() }}</p>
          <br />
          @if (assessmentDetail()?.assessmentProtectedAreas?.protectedAreas?.length) {
            <app-pa-table [protectedAreas]="assessmentDetail()?.assessmentProtectedAreas?.protectedAreas ?? []" />
          }
        </div>
      }
    </div>
  }
</div>
